export default __webpack_public_path__ + "static/media/navigation.82a9e2f7.yaml";